.root {
  align-items: center;
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: 12px;
  display: flex;
  font-size: 14px;
  gap: 8px;
  padding: 6px 6px 6px 12px;
  transition: border-color 0.15s, box-shadow 0.15s;

  &:focus-within {
    border-color: var(--color-focus);
    box-shadow: 0 0 0 2px var(--color-focus);
  }
}

.root-is-listening {
  border-color: var(--color-destructive);
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--color-destructive) 25%, transparent);
}

.leading-icon {
  color: var(--color-muted);
  display: inline-flex;
  flex-shrink: 0;
}

.field {
  background: transparent;
  border: none;
  flex: 1;
  font-size: inherit;
  outline: none;
  padding: 6px 0;

  &::placeholder {
    color: var(--color-placeholder);
  }

  &::-webkit-search-cancel-button {
    appearance: none;
  }
}

.clear-btn {
  align-items: center;
  background: var(--color-secondary);
  border: none;
  border-radius: 9999px;
  color: var(--color-foreground);
  cursor: pointer;
  display: inline-flex;
  flex-shrink: 0;
  height: 20px;
  justify-content: center;
  transition: background-color 120ms ease-out;
  width: 20px;

  &:hover {
    background: var(--color-border);
  }
}

.shortcut-chip {
  align-items: center;
  background: var(--color-secondary);
  border-radius: 4px;
  color: var(--color-muted);
  display: inline-flex;
  flex-shrink: 0;
  font-size: 11px;
  font-weight: 500;
  padding: 2px 6px;
}

.mic-btn {
  align-items: center;
  background: var(--color-foreground);
  border: none;
  border-radius: 8px;
  color: var(--color-background);
  cursor: pointer;
  display: inline-flex;
  flex-shrink: 0;
  height: 44px;
  justify-content: center;
  transition: background-color 0.15s;
  width: 44px;

  &:focus-visible {
    box-shadow: 0 0 0 2px var(--color-focus);
    outline: none;
  }
}

.mic-btn-is-active {
  background: var(--color-destructive);
  color: var(--color-background);
}

.mic-btn-is-disabled {
  background: var(--color-muted);
  color: var(--color-background);
  cursor: not-allowed;
  opacity: 0.5;
}

.listening-waveform {
  display: inline-flex;
  flex-shrink: 0;
  gap: 2px;
  height: 18px;
}

.listening-waveform-bar {
  animation: agent-search-bar-wave 0.9s ease-in-out infinite;
  background: var(--color-destructive);
  border-radius: 2px;
  width: 3px;
}

@keyframes agent-search-bar-wave {
  0%,
  100% {
    transform: scaleY(0.3);
  }

  50% {
    transform: scaleY(1);
  }
}
